(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kada-klaviyo-offer-button"]) return;
  try {
    
  if (!customElements.get('klaviyo-offer-button')) {
    customElements.define(
      'klaviyo-offer-button',
      class KlaviyoOfferButton extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          const formId = this.dataset.formId;
          const dismissKey = this.dataset.dismissKey;
          const conversionKey = this.dataset.conversionKey;
          const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
          let formSubmitted = false;

          const readStoredFlag = (storage, key) => {
            if (!key) return false;

            try {
              return storage.getItem(key) === 'true';
            } catch (error) {
              void error;
              return false;
            }
          };

          const writeStoredFlag = (storage, key) => {
            if (!key) return;

            try {
              storage.setItem(key, 'true');
            } catch (error) {
              void error;
            }
          };

          const hideButton = () => {
            this.hidden = true;
            this.removeAttribute('data-visible');
          };

          const showButton = () => {
            if (!isThemeEditor) {
              if (readStoredFlag(window.localStorage, conversionKey)) return;
              if (readStoredFlag(window.sessionStorage, dismissKey)) return;
            }

            this.hidden = false;
            this.setAttribute('data-visible', 'true');
          };

          hideButton();

          if (isThemeEditor) {
            showButton();
          }

          window.addEventListener(
            'klaviyoForms',
            (event) => {
              const detail = event.detail;

              if (!detail || detail.formId !== formId) return;

              if (detail.type === 'open') {
                formSubmitted = false;
                hideButton();
                return;
              }

              if (detail.type === 'submit' || detail.type === 'redirectedToUrl') {
                formSubmitted = true;
                hideButton();
                writeStoredFlag(window.localStorage, conversionKey);
                return;
              }

              if (detail.type === 'close' && !formSubmitted) {
                showButton();
              }
            },
            { signal }
          );

          this.querySelector('[data-klaviyo-offer-trigger]')?.addEventListener(
            'click',
            () => {
              window._klOnsite = window._klOnsite || [];
              window._klOnsite.push(['openForm', 'XDYJKM']);
            },
            { signal }
          );

          this.querySelector('[data-klaviyo-offer-close]')?.addEventListener(
            'click',
            () => {
              hideButton();

              if (!isThemeEditor) {
                writeStoredFlag(window.sessionStorage, dismissKey);
              }
            },
            { signal }
          );
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
